// extracted by mini-css-extract-plugin
export default {"policy":"Policy_policy__NLLmH","wrapper":"Policy_wrapper__eBa6M","addr":"Policy_addr__FCnU0","points":"Policy_points__mecsC","rules":"Policy_rules__3MQ5d"};